"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceType = exports.SourceName = exports.ServiceName = exports.WorkbookSize = exports.Error = exports.InitatingSource = exports.Closed = exports.ExpandHelpCount = exports.CloseDialogAndWorkbook = exports.CloseDialogOnly = exports.IsTableauOnline = exports.PrimaryActionCount = exports.RetryCount = exports.CloseButton = exports.PrimaryAction = exports.EventType = exports.ExitType = void 0;
exports.ExitType = 'ExitType';
exports.EventType = 'ConnectedExperienceDialog';
exports.PrimaryAction = 'PrimaryAction';
exports.CloseButton = 'CloseButton';
exports.RetryCount = 'RetryCount';
exports.PrimaryActionCount = 'PrimaryActionCount';
exports.IsTableauOnline = 'IsTableauOnline';
exports.CloseDialogOnly = 'CloseDialogOnly';
exports.CloseDialogAndWorkbook = 'CloseDialogAndWorkbook';
exports.ExpandHelpCount = 'ExpandHelpCount';
exports.Closed = 'Closed';
exports.InitatingSource = 'Source';
exports.Error = 'Error';
exports.WorkbookSize = 'WorkbookSize';
var ServiceName;
(function (ServiceName) {
    ServiceName["VizPortalClient"] = "vizportalclient";
    ServiceName["VizClient"] = "vizclient";
    ServiceName["Unknown"] = "unknown";
})(ServiceName = exports.ServiceName || (exports.ServiceName = {}));
var SourceName;
(function (SourceName) {
    SourceName["VizPortalClientWorkbook"] = "vizportalclient-workbook";
    SourceName["VizPortalClientView"] = "vizportalclient-view";
    SourceName["VizClientAuthoring"] = "vizclient-authoring";
    SourceName["VizClientViewing"] = "vizclient-viewing";
    SourceName["Unknown"] = "unknown";
})(SourceName = exports.SourceName || (exports.SourceName = {}));
var SourceType;
(function (SourceType) {
    SourceType[SourceType["VizPortalClientWorkbook"] = 0] = "VizPortalClientWorkbook";
    SourceType[SourceType["VizPortalClientView"] = 1] = "VizPortalClientView";
    SourceType[SourceType["VizClientAuthoring"] = 2] = "VizClientAuthoring";
    SourceType[SourceType["VizClientViewing"] = 3] = "VizClientViewing";
    SourceType[SourceType["Unknown"] = 4] = "Unknown";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
//# sourceMappingURL=TelemetryConstants.js.map